export const accountingAndAuditingConst = {
  path: "/single-programs/accounting-and-auditing",
  title: "ФАКУЛЬТЕТ ЭКОНОМИКИ И УПРАВЛЕНИЯ – БУХГАЛТЕРСКИЙ УЧЕТ И АУДИТ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Бухгалтерия и аудит — основа финансовой прозрачности</h2>
      <p>
        Программа готовит квалифицированных специалистов в сфере учета, аудита, налогового регулирования и финансового контроля. Студенты
        осваивают практики подготовки отчетности, налогового планирования и анализа, работают с национальными и международными стандартами
        (IFRS, GAAP).
      </p>
      <p>Образование направлено на развитие аналитического мышления, внимательности к деталям и уверенного владения профессиональным ПО.</p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Бухгалтерский и налоговый учет</li>
        <li>Финансовая отчётность и стандарты IFRS</li>
        <li>Управленческий учет и бюджетирование</li>
        <li>Аудит и внутренний контроль</li>
        <li>Налоговое право и оптимизация налогообложения</li>
        <li>Анализ и интерпретация финансовой информации</li>
        <li>Программные продукты (1С, SAP, Excel, QuickBooks)</li>
        <li>Этика и ответственность в профессии бухгалтера</li>
      </ul>
      <p>
        В программу входят практические задания, кейсы из компаний, имитации аудиторских проверок и подготовка к международным сертификациям
        (ACCA, CPA — по желанию студента).
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Бухгалтер (в компаниях, банках, НКО)</li>
        <li>Аудитор (внутренний или внешний)</li>
        <li>Финансовый контролер</li>
        <li>Налоговый консультант</li>
        <li>Специалист по управленческому учету</li>
        <li>Консультант по бухгалтерским системам</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€50,000 до €85,000 в год</strong>
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с признанием на рынке труда</li>
        <li>Возможность обучения на русском и английском языках</li>
        <li>Гибкие форматы: очно или дистанционно</li>
        <li>Современная учебная база и доступ к бухгалтерскому ПО</li>
        <li>Преподаватели — эксперты с опытом в крупных компаниях</li>
        <li>Поддержка приёмной комиссии на всех этапах обучения</li>
      </ul>
      <p>Финансовая точность — залог доверия в бизнесе. Мы учим работать без ошибок.</p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия поможет вам пройти весь путь — от выбора программы до подачи заявки.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очно или дистанционно
    Форма связи: Получить консультацию приемной комиссии
    Бухгалтерия и аудит — основа финансовой прозрачности
    Программа готовит квалифицированных специалистов в сфере учета, аудита, налогового регулирования и финансового контроля. Студенты осваивают практики подготовки отчетности, налогового планирования и анализа, работают с национальными и международными стандартами (IFRS, GAAP).
    Образование направлено на развитие аналитического мышления, внимательности к деталям и уверенного владения профессиональным ПО.
    Что вы будете изучать?
    • Бухгалтерский и налоговый учет
    • Финансовая отчётность и стандарты IFRS
    • Управленческий учет и бюджетирование
    • Аудит и внутренний контроль
    • Налоговое право и оптимизация налогообложения
    • Анализ и интерпретация финансовой информации
    • Программные продукты (1С, SAP, Excel, QuickBooks)
    • Этика и ответственность в профессии бухгалтера
    В программу входят практические задания, кейсы из компаний, имитации аудиторских проверок и подготовка к международным сертификациям (ACCA, CPA — по желанию студента).
    Кем можно работать после окончания?
    • Бухгалтер (в компаниях, банках, НКО)
    • Аудитор (внутренний или внешний)
    • Финансовый контролер
    • Налоговый консультант
    • Специалист по управленческому учету
    • Консультант по бухгалтерским системам
    Зарплата в Европе: от €50,000 до €85,000 в год
    Почему выбирают нас?
    • Европейский диплом с признанием на рынке труда
    • Возможность обучения на русском и английском языках
    • Гибкие форматы: очно или дистанционно
    • Современная учебная база и доступ к бухгалтерскому ПО
    • Преподаватели — эксперты с опытом в крупных компаниях
    • Поддержка приёмной комиссии на всех этапах обучения
    Финансовая точность — залог доверия в бизнесе. Мы учим работать без ошибок.

    Как поступить?
    Приёмная комиссия поможет вам пройти весь путь — от выбора программы до подачи заявки.
  `,
};
